<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    :multiple="multiple"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in items"
      :key="item.id"
      :label="item.attributes.title"
      :value="item.id"
    >
      {{ item.attributes.title }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'FeedSelect',
  props: {
    modelValue: {
      required: true,
      type: [String, Array]
    },
    items: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = function (newValue: any) {
      if (props.multiple) {
        context.emit(
          'update:modelValue',
          newValue.map((x: any) => String(x))
        )
      } else {
        context.emit('update:modelValue', String(newValue))
      }
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, value }
  }
})
</script>
